import { PROJECT_NAME } from "@/firebase/init";
import Component, { mixins } from "vue-class-component";
import { Watch } from "vue-property-decorator";
import mixin from "@/mixin";
import { db } from "@/main";
@Component
export default class Main extends mixins(mixin) {
  darkMode = true;
  UID = "";
  type = "";
  subType = "";
  userData = { profile_info: { image: "" } };
  items: any[] = [];
  projectName = "";
  color = "";
  drawer = null;
  drawerRight = null;
  item = null;
  srcImageDefault =
    "https://www.fancyhands.com/images/default-avatar-250x250.png";

  async mounted() {
    this.projectName = PROJECT_NAME;

    this.color = "#FF1736";
    console.log("ENTRO MOUNTED APP");
    console.log("UID: " + this.$store.state.user.uid);

    this.UID = this.$store.state.user.uid
    this.type = this.$store.state.user.type
    this.subType = this.$store.state.user.subType
    this.userData = this.$store.state.user.data
    if (this.userData !== null) {
      if (
        this.userData.profile_info !== null &&
        this.userData.profile_info !== undefined
      ) {
        if (
          this.userData.profile_info.image == undefined &&
          this.userData.profile_info.image == null
        ) {
          this.userData.profile_info.image = "";
        }
      }
    }
    console.log(this.items);
    if (this.type === "admin") {
      db.collection("admins")
        .doc(this.UID)
        .onSnapshot(doc => {
          console.log(this.items);
          this.items = [];
          for (const permission in doc.data()?.permissions) {
            if (permission !== "write") {
              this.items.push(doc.data()?.permissions[permission]);
            }
          }
          this.items.sort((a, b) => {
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
            return a.position - b.position;
          });
        });
    } else if (this.type === "user") {
      console.log("ES USER - APP VUE");
      db.collection("client_employees")
        .doc(this.UID)
        .onSnapshot(doc => {
          this.items = [];
          for (const permission in doc.data()?.permissions) {
            if (permission !== "write") {
              this.items.push(doc.data()?.permissions[permission]);
            }
          }
          this.items.sort((a, b) => {
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
            return a.position - b.position;
          });
        });
    }
  }
  @Watch("darkMode")
  onDarkModeChange(val) {
    this.$vuetify.theme.dark = val;
    console.log(val);
  }
}
